// extracted by mini-css-extract-plugin
export var fadeIn = "_df-1";
export var modalContent = "_df-3";
export var overlay = "_df-0";
export var popoverContent = "_df-2";
export var results = "_df-5";
export var searchInputWrapper = "_df-4";